import Image from '@root/assets/img/rob.png';
import React from 'react';
import { Link } from 'react-router-dom';

import FiveZeroZeroStyleWrapper from './500.styles';

export default function () {
  return (
    <FiveZeroZeroStyleWrapper className="iso500Page">
      <div className="iso500Content">
        <h1>500</h1>
        <h3>Error en el Servidor</h3>
        <p>Algo salió mal. Por favor, inténtelo de nuevo más tarde.</p>
        <Link to="/">
          <button type="button">Regresar al home</button>
        </Link>
      </div>

      <div className="iso500Artwork">
        <img alt="#" src={Image} />
      </div>
    </FiveZeroZeroStyleWrapper>
  );
}
